import { useMemo } from 'react'


const useMyProfileCategories = () => {

  const TABS = useMemo(
    () => [
      {
        label: 'Información Personal',
        value: 0,
      },
      {
        label: 'Verificación',
        value: 1,
      },
      {
        label: 'Cambiar Contraseña',
        value: 2,
      },
    ],
    [],
  )

  return { categories: TABS }
}

export default useMyProfileCategories
